// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9fe1561a","667":"11542367"}[chunkId] + ".chunk.js";
};